import { Component } from "react";

import { Button, ButtonGroup } from "components/button/Button";
import Expandable from "components/expandable/Expandable";
import { Icon } from "components/icon/Icon";
import CommitmentTable from "./CommitmentTable";
import VolumeAnalysis from "../VolumeAnalysis/VolumeAnalysis";

import "./Commitment.scss";

class Commitment extends Component {
  constructor(props) {
    super(props);

    const lastYearsReports =
      this.props.commitment.activityTable.yearlyReports[
        this.props.commitment.activityTable.yearlyReports.length - 2
      ];
    const lastYear = lastYearsReports ? lastYearsReports.year : null;

    this.state = {
      availableYears: this.props.commitment.activityTable.yearlyReports.map(
        (x) => {
          return x.year;
        }
      ),
      openYear:
        this.props.commitment.activityTable.yearlyReports[
          this.props.commitment.activityTable.yearlyReports.length - 1
        ].year,
      lastYear: lastYear,
      isClosed: true
    };

    this.toggleCommitment = this.toggleCommitment.bind(this);
  }

  toggleCommitment() {
    let lastYear =
      this.state.availableYears[this.state.availableYears.length - 2];
    this.setState({
      openYear: this.state.availableYears[this.state.availableYears.length - 1],
      lastYear: lastYear,
      isClosed: true
    });
  }

  handleYearChange(year) {
    this.setState((state) => {
      return {
        openYear: state.availableYears.find((x) => x === year),
        lastYear:
          state.availableYears[
            state.availableYears.findIndex((x) => x === year) - 1
          ]
      };
    });
  }

  render() {
    const header = (
      <div
        className={`commitmentHeader ${
          this.props.commitment.isAnomaly && "isAnomaly"
        } p-4`}
      >
        <strong>{this.props.commitment.uppdrag}</strong>
        <label>
          {this.props.commitment.kostnadsstalleNamn ||
            this.props.commitment.kontor}
        </label>
        <label>{this.props.commitment.kundnamn}</label>
        <label>Öppet PGU - {this.props.commitment.totalOpenAmount} SEK</label>
        <div>
          {this.props.commitment.activityTable.isFinalInvoice && (
            <Icon className="lagFinalInvoice" name="flag" title="Slutfaktura" />
          )}
          {this.props.commitment.activityTable.totalOpenAconto > 0 && (
            <Icon
              className="flagTotalOpenAmount"
              name="flag"
              title="Slutreglering av betalningen kommer att ske i samband med slutbetalning av det utförda arbetet"
            />
          )}
        </div>
      </div>
    );

    const footer = <div className={`p-5`}></div>;

    return (
      <div className={`box p-0 pr-4 mb-5`}>
        <Expandable
          header={header}
          startMinimized={this.state.isClosed}
          shrinkIconText={"Stäng"}
          expandIconText={"Öppna"}
          footer={footer}
        >
          <div className={"p-4"}>
            <div className="commitmentControls">
              <div className={"mb-5"}>
                <h3>Visa år</h3>
                <ButtonGroup>
                  {this.props.commitment.activityTable.yearlyReports.map(
                    (rep) => {
                      let yearHasOpenAmount = rep.openAmount > 0;
                      return (
                        <Button
                          size={"sm"}
                          color={yearHasOpenAmount ? "tertiary" : undefined}
                          active={rep.year === this.state.openYear}
                          key={rep.year}
                          onClick={() => {
                            this.handleYearChange(rep.year);
                          }}
                        >
                          {rep.year}
                        </Button>
                      );
                    }
                  )}
                </ButtonGroup>
              </div>
            </div>
            <CommitmentTable
              id={this.props.commitment.id}
              year={this.state.openYear}
              lastYear={this.state.lastYear}
              commitment={this.props.commitment}
              close={this.toggleCommitment}
            />
          </div>

          <VolumeAnalysis
            key={`VolumeAnalysis${this.props.commitment.kundnummer}`}
            customerId={this.props.commitment.kundnummer}
          ></VolumeAnalysis>
        </Expandable>
      </div>
    );
  }
}

export default Commitment;
